import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
    mutations: {
      retry: 0,
    },
  },
});

export const qk = {
  projects: ['projects'] as const,
  projectsByStatus: (status?: string) => ['projects', { status }] as const,
  project: (id: string) => ['projects', id] as const,
  usage: (days: number) => ['usage', days] as const,
  accounts: ['accounts'] as const,
  messages: (filters?: Record<string, unknown>) => ['messages', filters] as const,
  message: (id: string) => ['messages', id] as const,
  drafts: (status?: string) => ['drafts', status ?? 'pending'] as const,
  draft: (id: string) => ['drafts', id] as const,
  threadSummary: (messageId: string) => ['threadSummary', messageId] as const,
  renovation: (projectId: string) => ['renovation', projectId] as const,
  briefs: ['briefs'] as const,
  brief: (id: string) => ['briefs', id] as const,
  calendarEvents: (params?: Record<string, unknown>) => ['calendar-events', params] as const,
  calendarStatus: ['calendar-status'] as const,
  accountCalendars: (accountId: string) => ['account-calendars', accountId] as const,
  roomMedia: (roomId: string, kind?: string) => ['room-media', roomId, kind ?? null] as const,
  mediaPins: (mediaId: string) => ['media-pins', mediaId] as const,
  projectChat: (projectId: string) => ['project-chat', projectId] as const,
};
